import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  rating: number;
  year: number;
  updateInfo: string;
  image: string;
  size?: 'normal' | 'large';
}

export default function VideoCard({
  title,
  category,
  categorySlug,
  rating,
  year,
  updateInfo,
  image,
  size = 'normal',
}: VideoCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/category/${categorySlug}`}
      className="group cursor-pointer block"
    >
      <div
        className={`relative overflow-hidden rounded-xl bg-background-200 ${
          isLarge ? 'aspect-[16/9]' : 'aspect-[3/4]'
        }`}
      >
        <img
          src={image}
          alt={title}
          title={`${title} - 国产视频在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
            {rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-4">
          <p className="text-xs text-white/70 mb-1">
            {year} · {category}
          </p>
          <h3 className="text-sm md:text-base font-bold text-white leading-tight line-clamp-2">
            {title}
          </h3>
          <p className="text-xs text-white/60 mt-1.5">
            {updateInfo}
          </p>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}